import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Auth } from 'aws-amplify';

import http from 'src/api/endpoints';
import { errorHelper } from 'src/utils';
import { PARENT_URL } from 'src/config/parentURL';

export const getUserProfile = createAsyncThunk('profile', async (_, thunk) => {
  try {
    const user = await http.getProfile(PARENT_URL.BASE_SERVER);
    const { data } = user || {};
    if (data) {
      localStorage.setItem('profile', JSON.stringify(data));
    }
    return data;
  } catch (error) {
    console.log(error);
    await Auth.signOut();
    return thunk.rejectWithValue(errorHelper(error));
  }
});
interface InitialState {
  loading: boolean;
  isAuthenticated: boolean;
  profile: any;
}

const initialState: InitialState = {
  isAuthenticated: false,
  loading: false,
  profile: null,
};

export const userProfile = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getUserProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(getUserProfile.rejected, (state) => {
        state.isAuthenticated = false;
        state.loading = false;
        state.profile = null;
      });
  },
});
